import { Flex, rem } from "@mantine/core";
import CustomInput from "src/generator/CustomInput/CustomInput";

interface Props {
  uuid: string;
  value: { sys: number; dia: number };
  width: string;
  required?: boolean;
  hideSuffix?: boolean;
  additionalOnChange?: (value: any, id?: string) => void;
  additionalOnBlur?: (e: any, subTag: string) => void;
}

const BloodPressure = ({
  uuid,
  value,
  hideSuffix,
  additionalOnBlur,
  ...cell
}: Props) => {
  return (
    <Flex gap={rem(8)} direction="column" style={{ width: cell.width }}>
      <CustomInput
        numeric
        {...cell}
        required={Boolean(cell.required)}
        suffix={!hideSuffix && "SYS"}
        value={value?.sys}
        id={`${uuid}.sys`}
        additionalOnBlur={e => additionalOnBlur?.(e, "sys")}
      />
      <CustomInput
        numeric
        {...cell}
        required={Boolean(cell.required)}
        suffix={!hideSuffix && "DIA"}
        value={value?.dia}
        id={`${uuid}.dia`}
        additionalOnBlur={e => additionalOnBlur?.(e, "dia")}
      />
    </Flex>
  );
};

export default BloodPressure;
